const pageNameKey = "pleaseWaitWhileProcessing";

export const pleaseWaitWhileProcessingEn = {
  [pageNameKey]: {
    info: "Your nodes are being loaded, please stand by...",
  },
};

export const pleaseWaitWhileProcessingPtBr = {
  [pageNameKey]: {
    info: "Seus nós estão sendo carregados, aguarde...",
  },
};

export const pleaseWaitWhileProcessingDe = {
  [pageNameKey]: {
    info: "Ihre Daten werden geladen, bitte warten Sie...",
  },
};

export const pleaseWaitWhileProcessingZhHans = {
  [pageNameKey]: {
    info: "您的节点正在处理，请稍候...",
  },
};

export const pleaseWaitWhileProcessingIt = {
  [pageNameKey]: {
    info: "I tuoi nodi vengono caricati, attendi...",
  },
};

export const pleaseWaitWhileProcessingEs = {
  [pageNameKey]: {
    info: "Se están cargando tus nodos, por favor espera...",
  },
};

export const pleaseWaitWhileProcessingNl = {
  [pageNameKey]: {
    info: "Uw nodes worden geladen, een ogenblik geduld...",
  },
};

export const pleaseWaitWhileProcessingTr = {
  [pageNameKey]: {
    info: "Düğümleriniz yükleniyor, lütfen beklemede kalın...",
  },
};
